<template>
  <div
    class="flex flex-col text-center cursor-pointer px-1 md:px-5 items-center hover:text-action"
    @click="showNewProjectModal"
  >
    <span class="pb-2 flex items-center text-action">
      <font-awesome-icon icon="plus-circle" size="lg"></font-awesome-icon>
    </span>
    <span v-text="label"></span>
  </div>
</template>

<script>
import NewProjectModal from "../Projects/NewProject/Modal";
import NewProjectModalConfig from "../Modals/configs/newproject";

export default {
  props: ["label"],
  data: function () {
    return {};
  },
  methods: {
    showNewProjectModal() {
      let step = 1;

      if (this.$store.state.app.lastRenderer) {
        step = 4;
      }

      this.$modal.show(NewProjectModal, { step }, NewProjectModalConfig);
    },
  },
  mounted() {
    if (this.$route.query.new) {
      this.showNewProjectModal();
    }
  },
};
</script>
